module.exports = __webpack_public_path__ + "b182bc6b19547c3201b3dd560888d816.svg";